export const dayOfYear = (date) =>
  Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24)

export const addDays = (days) => {
  const result = new Date()
  result.setDate(result.getDate() + days)
  return result
}
